import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

import { IntlProvider } from 'react-intl';
import localeSvc from 'services/localeService';

export class Locale extends React.Component {
  static propTypes = {
    locale: PropTypes.string.isRequired,
    children: PropTypes.element.isRequired
  };

  get messages () {
    return localeSvc.getMessages(this.props.locale);
  }

  render () {
    const { locale, children } = this.props;

    return (
      <IntlProvider locale={locale} messages={this.messages}>
        {children}
      </IntlProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  locale: state.locale || 'en'
});

const ConnectLocale = connect(mapStateToProps)(Locale);

export default ConnectLocale;



/** WEBPACK FOOTER **
 ** ./src/containers/Locale.js
 **/